<template>
    <div
        class="apprentice-simple-card"
        v-if="loaded">
        <div id="invite-checker-table">
            <design-2021-apprentice-data-table
                :items="groupsWithStatus"
                :fields="fields"
                :show-empty="true"
                :filter-function="advancedFilter">
                <template v-slot:options>
                    <b-button
                        class="btn-download"
                        :href="downloadUrl"
                        target="_blank"
                        variant="primary">
                        Download
                    </b-button>
                </template>

                <template v-slot:cell(students)="data">
                    <span
                        v-for="student in data.item.group_pair_students"
                        style="display: block"
                        >{{ student.user.full_name }}
                    </span>
                </template>

                <template v-slot:cell(teachers)="data">
                    <span
                        v-for="teacher in data.item.group_pair_group_teachers"
                        style="display: block"
                        >{{ teacher.user.full_name }}
                    </span>
                </template>

                <template v-slot:cell(status)="data">
                    <b-button
                        class="btn-recycle btn-reopen"
                        v-if="data.item.status === 1"
                        disabled
                        variant="warning-icon-only">
                    </b-button>
                    <b-button
                        class="btn-checked btn-approved"
                        v-else-if="data.item.status === 2"
                        disabled
                        variant="success-icon-only">
                    </b-button>
                    <b-button
                        class="btn-hourglass-start btn-pending"
                        v-else
                        disabled
                        variant="warning-icon-only">
                    </b-button>
                </template>

                <template v-slot:cell(actions)="data">
                    <div class="actions">
                        <b-button
                            class="btn-show btn-view-invite"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :title="$t('common.view')"
                            @click="showGroupModalActual(data.item)">
                        </b-button>
                        <b-button
                            class="btn-show btn-history"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :title="$t('group_pair.view_log')"
                            @click="showGroupModalLog(data.item)">
                        </b-button>

                        <b-button
                            class="btn-recycle btn-reopen"
                            v-if="data.item.status === 2"
                            v-b-tooltip.hover
                            @click="reopenGroup(data.item)"
                            :title="$t('group_pair.reopen')"
                            variant="warning-icon-only">
                        </b-button>
                    </div>
                </template>

                <template #empty="scope">
                    <div class="not-found">
                        <div class="icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="alert-notice group-admin-message">
                            {{ $t('group_pair.no_groups_created_yet') }}
                        </div>
                    </div>
                </template>
            </design-2021-apprentice-data-table>
        </div>
        <design-2021-group-pair-index-show-group-modal
            ref="show-group-modal"
            :group-pair-options-in="groupIn.group_pair_options"
            :coordinator-in="coordinatorIn"
            @saveCall="saveCall">
        </design-2021-group-pair-index-show-group-modal>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-group-pair-index-overview-component',
    props: ['groupIn', 'coordinatorIn'],
    data() {
        return {
            loaded: false,
            groups: [],
            check_option: this.groupIn.group_pair_options.check_option,
            fields: [
                {
                    key: 'students',
                    label: this.$t('group_pair.students'),
                    sortable: true,
                },
                {
                    key: 'teachers',
                    label: this.$t('group_pair.teachers'),
                    sortable: true,
                },
                {
                    key: 'subject',
                    label: this.$t('group_pair.subject'),
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: (value, key, item) => {
                        return value ? value : 0;
                    },
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            downloadUrl: this.routes.baseUrl() + this.routes.groupPairDownloadOverview(this.groupIn.id),
        };
    },
    computed: {
        groupsWithStatus() {
            return this.groups
                .map((group) => {
                    let formatted_group = { ...group };
                    formatted_group.status = group.getStatus(this.check_option);
                    return formatted_group;
                })
                .sort(function (a, b) {
                    return a.accepted - b.accepted;
                });
        },
    },
    methods: {
        showGroupModalActual(groupPairGroup) {
            this.$refs['show-group-modal'].show(groupPairGroup, this.$t('group.index.content'));
        },
        showGroupModalLog(groupPairGroup) {
            this.$refs['show-group-modal'].show(groupPairGroup, 'Log');
        },
        reopenGroup(group_pair_group) {
            this.alert
                .confirm(
                    this.$t('group_pair.reopen_group'),
                    this.$t('group_pair.are_you_sure_you_want_to_reopen_this_paper_will_be_deleted'),
                    this.$t('group_pair.reopen'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.post(this.routes.groupPairReopen(group_pair_group.id)).then(
                            (response) => {
                                const studentIds = group_pair_group.group_pair_students.map((student) => student.id);

                                ords.hold();

                                ords.use('group_pair_groups').update({ project_id: null }, group_pair_group.id);
                                ords.use('group_pair_students').update({ group_pair_id: null }, studentIds);
                                ords.use('group_pair_groups').detach(
                                    group_pair_group.id,
                                    'group_pair_students',
                                    studentIds,
                                );

                                ords.continue();

                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        saveCall(form) {
            let data = {
                remove_teacher_ids: form.remove_teacher_ids,
                status_teacher: form.status_teacher,
                status_coordinator: form.status_coordinator,
                feedback: form.feedback,
                removed_group_pair_student_ids: form.removed_group_pair_student_ids,
            };

            this.alert.saving();

            this.axios.post(this.routes.groupPairUpdateStatus(form.id), data).then(
                (response) => {
                    ords.hold();
                    ords.use('group_pair_groups').update(response.data, form.id);

                    if (form.removed_group_pair_student_ids.length) {
                        ords.use('group_pair_groups').detach(
                            form.id,
                            'group_pair_students',
                            form.removed_group_pair_student_ids,
                        );
                        ords.use('group_pair_students').update(
                            { group_pair_id: null },
                            form.removed_group_pair_student_ids,
                        );
                    }

                    if (form.remove_teacher_ids.length) {
                        ords.use('group_pair_group_teachers').remove(form.remove_teacher_ids);
                    }
                    ords.continue();

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        advancedFilter(row, filter) {
            const explanation = this.$options.filters.normalize_string(row.explanation);
            const cleanFilter = this.$options.filters.normalize_string(filter);

            if (explanation.indexOf(cleanFilter) !== -1) {
                return true;
            }

            for (const student of row.group_pair_students) {
                const name = this.$options.filters.normalize_string(student.user.full_name);
                if (name.indexOf(cleanFilter) !== -1) {
                    return true;
                }
            }

            for (const teacher of row.group_pair_group_teachers) {
                const name = this.$options.filters.normalize_string(teacher.user.full_name);
                if (name.indexOf(cleanFilter) !== -1) {
                    return true;
                }
            }

            return false;
        },
    },

    mounted() {
        if (!this.loaded) {
            ords.use('group_pair_groups')
                .with('group_pair_group_courses', (GroupPairGroupCourses) => {
                    GroupPairGroupCourses.with('course');
                })
                .with('group_pair_group_teachers', (GroupPairGroupTeachers) => {
                    GroupPairGroupTeachers.with('user', (userCallback) => {
                        userCallback.with('group_pair_group_teachers', (cb) => {
                            cb.with('group_pair_groups');
                        });
                        userCallback.with('group_pair_teachers');
                    });
                })
                .with('group_pair_students', (GroupPairStudents) => {
                    GroupPairStudents.with('user');
                })
                .whereHas('group_pair_students')
                .get()
                .subscribe((groups) => {
                    this.groups = groups;
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-direction: row;
    flex: 1;

    .btn:not(:last-child) {
        margin-right: 0;
        margin-bottom: 0;
    }
}

.btn-reopen,
.btn-pending {
    &:hover {
        color: $warning;
    }
}

.btn-approved {
    &:hover {
        color: $success;
    }
}
</style>
